import { createApp } from 'vue'
import './css/style.css'
import 'floating-vue/dist/style.css'
import DialogContainer from './DialogContainer.vue'
import Header from './components/header/Header.vue'
import InvestmentProcess from './InvestmentProcess.vue'
import LegalAccount from './LegalAccount.vue'
import LoginRegisterModal from './utilities/loginRegisterModal/LoginRegisterModal.vue'
import MissingDataModal from './utilities/missingDataModal/MissingDataModal.vue'
import Order from './Order.vue'
import Orders from './Orders.vue'
import PersonalAccount from './PersonalAccount.vue'
import Wallet from './Wallet.vue'

import { createPinia } from 'pinia'
import { i18n } from './localization'
import './typings'
import './validation'
import FloatingVue from 'floating-vue'
import * as Sentry from '@sentry/vue'

import VueSocialSharing from 'vue-social-sharing'
import Wizard from './Wizard.vue'

// The listener makes sure that window variables for translations etc. have been initialized
// when creating the Vue App object

window.addEventListener('DOMContentLoaded', () => {
    const dialogContainer = createApp(DialogContainer)
    const header = createApp(Header)
    const investmentProcess = createApp(InvestmentProcess)
    const legalAccount = createApp(LegalAccount)
    const loginRegisterModal = createApp(LoginRegisterModal)
    const missingDataModal = createApp(MissingDataModal)
    const order = createApp(Order)
    const orders = createApp(Orders)
    const personalAccount = createApp(PersonalAccount)
    const wallet = createApp(Wallet)
    const wizard = createApp(Wizard)

    if (import.meta.env.PROD) {
        Sentry.init({
            app: [
                dialogContainer,
                header,
                investmentProcess,
                legalAccount,
                loginRegisterModal,
                missingDataModal,
                order,
                orders,
                personalAccount,
                wallet,
                wizard,
            ],
            dsn: 'https://e1d957ab9e614d4896f6aa4379d24008@o136928.ingest.sentry.io/6392712',
            // Set tracesSampleRate to 1.0 to capture 100%
            // of transactions for performance monitoring.
            // We recommend adjusting this value in production
            tracesSampleRate: 1.0,
        })
        Sentry.attachErrorHandler(dialogContainer, { logErrors: true })
        Sentry.attachErrorHandler(header, { logErrors: true })
        Sentry.attachErrorHandler(investmentProcess, { logErrors: true })
        Sentry.attachErrorHandler(legalAccount, { logErrors: true })
        Sentry.attachErrorHandler(loginRegisterModal, { logErrors: false })
        Sentry.attachErrorHandler(missingDataModal, { logErrors: false })
        Sentry.attachErrorHandler(order, { logErrors: true })
        Sentry.attachErrorHandler(orders, { logErrors: true })
        Sentry.attachErrorHandler(personalAccount, { logErrors: true })
        Sentry.attachErrorHandler(wallet, { logErrors: true })
        Sentry.attachErrorHandler(wizard, { logErrors: true })
    }

    const mainStore = createPinia()

    dialogContainer.use(mainStore).use(i18n).mount('#conda-header-notification-container')
    header.use(mainStore).use(i18n).mount('#header-v2')
    investmentProcess.use(mainStore).use(i18n).use(FloatingVue).mount('#conda-investment-process')
    legalAccount.use(mainStore).use(i18n).use(FloatingVue).use(VueSocialSharing).mount('#legal-account')
    loginRegisterModal.use(i18n).use(FloatingVue).mount('#login-register-modal-v2')
    missingDataModal.use(i18n).use(FloatingVue).mount('#missing-data-modal-v2')
    order.use(mainStore).use(i18n).use(FloatingVue).mount('#order-v2')
    orders.use(mainStore).use(i18n).use(FloatingVue).mount('#orders-v2')
    personalAccount.use(mainStore).use(i18n).use(FloatingVue).use(VueSocialSharing).mount('#personal-account')
    wallet.use(mainStore).use(i18n).use(FloatingVue).mount('#wallet-v2')
    wizard.use(mainStore).use(i18n).use(FloatingVue).mount('#conda-wizard')
})
